


















































































































import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import innerGroup from './VariableInnerGroup.vue';
Vue.component('innerGroup', innerGroup);
@Component
export default class VariableScreen extends Vue {
  @Prop() private variableList!: any;

  @Emit('emitAddress')
  private emitAddress(address: string, target: string, index?: number) {
  }
}
